module.exports = __webpack_public_path__ + "static/media/ht-app-phone4-2x.0dc54073.png";